<template>
	<div class="modifyPwd">
		<el-dialog :visible.sync="dialogVisible" width="600px" top="26vh" :close-on-click-modal="false" :show-close="false"
			@close="close">
			<div class="title">修改密码</div>
			<span class="iconfont icon-guanbi" @click="dialogVisible = false"></span>
			<el-form :model="userForm" ref="userForm" :rules="rules" label-width="130px" label-position="left">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="原密码：" prop="oldPwd">
							<el-input v-model="userForm.oldPwd" :type="pwdInputType1" placeholder="若不记得原密码，可以联系老师">
                <i slot="suffix" @click="pwdInputType1 = pwdInputType1 === 'password'?'text':'password'" style="cursor: pointer" :class="pwdInputType1==='text'?'icon-pwd-show':'icon-pwd-hide'" class="iconfont"></i>
              </el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="新密码：" prop="newPwd">
							<el-input v-model="userForm.newPwd" :type="pwdInputType2" placeholder="请输入新密码">
                <i slot="suffix" @click="pwdInputType2 = pwdInputType2 === 'password'?'text':'password'" style="cursor: pointer" :class="pwdInputType2==='text'?'icon-pwd-show':'icon-pwd-hide'" class="iconfont"></i>
              </el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="确认密码：" prop="newAgainPwd">
							<el-input v-model="userForm.newAgainPwd" :type="pwdInputType3" placeholder="请输入确认密码">
                <i slot="suffix" @click="pwdInputType3 = pwdInputType3 === 'password'?'text':'password'" style="cursor: pointer" :class="pwdInputType3==='text'?'icon-pwd-show':'icon-pwd-hide'" class="iconfont"></i>
              </el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="dialog-footer">
				<el-button type="primary" @click="submitForm" style="background-color: #00E5FF;color: #0C3151;">确 定</el-button>
				<el-button @click="dialogVisible = false" style="margin-left: 70px;background-color: #BABEBE;">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		modifyPwd
	} from '@/api/user'
	export default {
		name: "modifyPwd",
		data() {
			let validateAgainPwd = (rule, value, callback) => {
				let newPwd = this.userForm.newPwd;
				if (value == "") callback(new Error("确认密码不能为空"));
				else if (value != newPwd) callback(new Error("两次密码不一致"));
				else callback();
			}
			return {
				dialogVisible: false,
        pwdInputType1: 'password',
        pwdInputType2: 'password',
        pwdInputType3: 'password',
				userForm: {
					userId: "",
					oldPwd: "",
					newPwd: "",
					newAgainPwd: "",
				},
				rules: {
					oldPwd: [{
						required: true,
						message: '原密码不能为空',
						trigger: 'blur'
					}],
					newPwd: [{
						required: true,
						message: '新密码不能为空',
						trigger: 'blur'
					}, {
						pattern: /^[a-zA-Z0-9]{6,18}$/,
						message: '密码由 6-18 个大小写字母和数字组成',
						trigger: 'blur'
					}],
					newAgainPwd: [{
						required: true,
						message: '确认新密码不能为空',
						trigger: 'blur'
					}, {
						validator: validateAgainPwd,
						trigger: 'blur'
					}],
				}
			}
		},
		created: function() {},
		mounted: function() {},
		methods: {
			show(row) {
				this.dialogVisible = true;
				this.userForm.userId = row.userId;
			},
			close() {
				this.dialogVisible = false;
				this.userForm = {
						userId: "",
						oldPwd: "",
						newPwd: "",
						newAgainPwd: "",
					},
					this.$nextTick(() => {
						this.$refs.userForm.clearValidate(); //关闭清空校验规则
					})
			},
			submitForm() {
				this.$refs.userForm.validate(async (valid) => {
					if (valid) {
						let res = await modifyPwd({
							oldPwd: this.userForm.oldPwd,
							newPwd: this.userForm.newPwd
						});
						if (res.status == 1) {
							this.$message.success(res.message);
							this.close();
						} else {
							this.$message.warning(res.message);
						}
					} else {
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.modifyPwd {

		::v-deep .el-dialog {
			background: url(~@/assets/img/pwdBg.png) no-repeat;
			background-size: 100% 100%;
			color: #FFF;
			height: 396px;

			.el-dialog__header {
				display: none;
			}

			.el-dialog__body {
				padding: 108px 60px 30px;
				position: relative;

				.title {
					position: absolute;
					top: 10px;
					left: 50%;
					transform: translate(-50%, 0);
					color: #D4F0FF;
					font-size: 32px;
					font-weight: 400;
				}

				.icon-guanbi {
					position: absolute;
					right: 32px;
					top: 55px;
					color: #98DCFF;
					font-size: 20px;
					cursor: pointer;
				}

				.el-form {

					.el-form-item {

						.el-form-item__label {
							color: #FFF;
							font-size: 18px;
						}

						.el-input__inner {
							border: none;
							background-color: #22739E;
							border-radius: 8px;
							height: 42px;
							line-height: 42px;
							font-size: 18px;
							color: #FFF;
						}
					}
				}
			}

			.dialog-footer {
				display: flex;
				justify-content: center;
				margin-top: 18px;

				.el-button {
					font-size: 20px;
					padding: 11px 40px;
					border: none;
				}
			}
		}
	}
</style>
